import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, NewsletterSection, Features, Team, ProjectSection, Banner, Pricing, Process, Skills, FAQs, GetQuote, Clients } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <WhyUs /> {/* Why Choose Us section */}
      <Services /> {/* Services Slider */}
      <Counter /> {/* Counter Section */}
      <Process /> {/* Process Slider */}
      <Skills /> {/* Our Skills Section */}
      <ProjectSection /> {/* Project Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Banner /> {/* Banner Section */}
      <FAQs /> {/* FAQs Section */}
      <GetQuote /> {/* Get Quote Section */}
      <Pricing /> {/* Pricing Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;